import Vue from 'vue'
import VueRouter from 'vue-router'
// import home from './components/home/home.vue'
import mediaNav from './components/medianav/medianav.vue'
Vue.use(VueRouter)
const Router = new VueRouter({
	mode: 'history',
	base: __dirname,
	routes: [
		{
			path: '/',
			redirect: '/medianav/web'
		},
		{
			path: '/home',
			redirect: '/medianav/web'
	    },
	    {
	    	path: '/medianav/:type',
	    	component: mediaNav,
	    	name: '联盟中心-盘石媒介联盟中心'
	    }
	]
})
Router.afterEach((to, from, next) => {
	let myName = ''
	myName = to.name
	if (to.params.type) {
		if (to.params.type === 'web') {
			myName = ['网站', to.name].join('')
		} else {
			myName = ['移动', to.name].join('')
		}
	}
	document.title = myName
})

export default Router



// WEBPACK FOOTER //
// ./src/router.js